import { ReactComponent as LanguageIcon } from "../../assets/icons/bagstage_language.svg";
import i18n from "../../service/translations/translationService";
import homePageStyles from "../../styles/homePage.module.css";
import tooltipStyles from "../../styles/tooltip.module.css";
import { languages, languagesFullForm } from "../../utils/commonUtil";
import ClickableTooltip from "../UI/tooltips/ClickableTooltip";
import LanguageOptionButton from "./LanguageOptionButton";

export default function LanguageSelectionTooltip() {
  return (
    <ClickableTooltip
      icon={
        <div className={homePageStyles.languageSection}>
          <p className={homePageStyles.selectedLanguage}>
            {i18n.language.toUpperCase()}
          </p>
          <LanguageIcon width={16} height={16} />
        </div>
      }
      classes={tooltipStyles.languageTooltipContent}
    >
      <LanguageOptionButton
        optionName={languagesFullForm.danish}
        language={languages.da}
      />
      <LanguageOptionButton
        optionName={languagesFullForm.english}
        language={languages.en}
      />
    </ClickableTooltip>
  );
}
